export const countWords = (str) => {
    if (typeof str === 'string') {
        str = str.replace(/(^\s*)|(\s*$)/gi, '');
        str = str.replace(/[ ]{2,}/gi, ' ');
        str = str.replace(/\n /, '\n');
        return str.split(' ').length;
    }
    return 0;
};
